import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoginMobileNative from './LoginMobileNative';
import { isMobileViewport, WEB_LOGIN_PATH } from '../utils/authRoutes';

/**
 * Point d'entrée `/mobile/login` : sur grand écran, propose la connexion web
 * sauf si `?native=1` force le parcours mobile (tests / WebView).
 */
const MobileLoginEntry = () => {
  const location = useLocation();
  const forceNative = new URLSearchParams(location.search).get('native') === '1';

  if (!forceNative && !isMobileViewport()) {
    return <Navigate to={WEB_LOGIN_PATH} replace state={location.state} />;
  }

  return <LoginMobileNative />;
};

export default MobileLoginEntry;
